import styled$1, { css } from 'styled-components';
import { space, mq, DebugGrid } from '@ccg/core';
import React$1 from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';

const getOuterGridContainer = () => css(["width:100%;display:flex;flex-direction:column;align-items:center;"]);
const getInnerGridContainer = () => css(["width:100%;max-width:1440px;"]);
const getOuterMargins = () => css(["margin-right:", ";margin-left:", ";", "{margin-right:", ";margin-left:", ";}", "{margin-right:", ";margin-left:", ";}"], space(5), space(5), mq('m'), space(13), space(13), mq('l'), space(16), space(16));
const getColumns = (theme, columnsConfig) => {
  let columnsCSS = '';
  Object.keys(columnsConfig).forEach(key => {
    const item = columnsConfig[key];
    const string = key === 'default' ? `grid-template-columns: repeat(${item}, 1fr);` : `${mq(key)({
      theme
    })} { grid-template-columns: repeat(${item}, 1fr);}`;
    columnsCSS += string;
  });
  return columnsCSS;
};
const getGridColumnGap = theme => {
  let columnsGapCSS = '';
  Object.keys(theme.grid.gutters).forEach(key => {
    const gutter = theme.grid.gutters[key];
    const string = key === 'default' ? `grid-column-gap: ${gutter};` : `${mq(key)({
      theme
    })} { grid-column-gap: ${gutter};}`;
    columnsGapCSS += string;
  });
  return columnsGapCSS;
};
const getGrid = (gridColumns, outerMargins = true) => ({
  theme
}) => {
  const columns = getColumns(theme, gridColumns || theme.grid.columns);
  const columnGap = getGridColumnGap(theme);
  return css(["display:grid;", ";", ";", ""], columnGap, columns, outerMargins && getOuterMargins());
};
const StyledGrid = styled$1.div`
  position: relative;
  ${props => getGrid(props.columns, props.hasOuterMargins)}
`;
const StyledDebugGrid = styled$1(DebugGrid)`
  ${props => getGrid(props.theme.grid.columns, false)}
`;
const Grid = React$1.forwardRef((_ref, ref) => {
  let {
    className,
    children,
    columns,
    hasOuterMargins
  } = _ref,
      props = _objectWithoutProperties(_ref, ["className", "children", "columns", "hasOuterMargins"]);

  return /*#__PURE__*/React$1.createElement(StyledGrid, _extends({}, props, {
    className: className,
    columns: columns,
    hasOuterMargins: hasOuterMargins,
    ref: ref
  }), children, process.env.NODE_ENV === 'development' && /*#__PURE__*/React$1.createElement(StyledDebugGrid, null));
});
Grid.displayName = 'Grid';
Grid.propTypes = {
  className: PropTypes$1.string,
  children: PropTypes$1.node,
  hasOuterMargins: PropTypes$1.bool,
  columns: PropTypes$1.shape()
};
Grid.defaultProps = {
  className: '',
  children: null,
  hasOuterMargins: true,
  columns: null
};

export default Grid;
export { getColumns, getGrid, getGridColumnGap, getInnerGridContainer, getOuterGridContainer, getOuterMargins };
